import {groupSubscriptionService} from '../services'

const state = {
    subscriptions: [],
    tiers: [],
    offers: [],
    invites: {},
    invite: {},
    myInvites: [],
    busy: false
}

const actions = {

    getAll ({ dispatch, commit }, params) {
        commit('loadListRequest')
        return groupSubscriptionService.getAll(params).then(
            response => {
                commit('loadListSuccess', response)
                return response
            },
            error => {
                commit('loadListError')
                dispatch('alert/error', 'Unable to load group subscriptions: ' + error, { root: true })
            }
        )
    },

    create ({ dispatch, commit }, params) {
        commit('startRequest')
        return groupSubscriptionService.create(params).then(
            response => {
                commit('endRequest')
                dispatch('alert/success', 'Group subscription has been created successfully', { root: true })
                return response
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to create benefit: ' + error, { root: true })
            }
        )
    },

    update ({ dispatch, commit }, params) {
        commit('startRequest')
        return groupSubscriptionService.update(params).then(
            response => {
                commit('endRequest')
                dispatch('alert/success', 'Group subscription has been updated successfully', { root: true })
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to update benefit: ' + error, { root: true })
            }
        )
    },

    remove ({ dispatch, commit }, params) {
        commit('startRequest')
        return groupSubscriptionService.remove(params).then(
            response => {
                commit('endRequest')
                dispatch('alert/success', 'Group subscription has been removed successfully', { root: true })
            },
            error => {
                commit('endRequest')
                dispatch('alert/error', 'Unable to remove benefit: ' + error, { root: true })
            }
        )
    },

    loadInvites ({ dispatch, commit }, memberGuid) {
        commit('loadInvitesRequest')
        return groupSubscriptionService.getInvites(memberGuid).then(
            response => {
                commit('loadInvitesSuccess', response)
                return response
            },
            error => {
                commit('loadInvitesError')
                dispatch('alert/error', 'Unable to load invites: ' + error, { root: true })
            }
        )
    },

    createInvite ({ dispatch, commit }, params) {
        commit('loadInviteRequest')
        return groupSubscriptionService.createInvite(params).then(
            response => {
                commit('loadInviteSuccess', response)
                dispatch('alert/success', 'Invitation sent!', { root: true })
                return response
            },
            error => {
                commit('loadInviteError')
                dispatch('alert/error', error, { root: true })
            }
        )
    },

    removeInvite ({ dispatch, commit }, params) {
        commit('loadInviteRequest')
        return groupSubscriptionService.removeInvite(params).then(
            response => {
                commit('loadInviteSuccess', response)
                dispatch('alert/success', 'The invitation was deleted.', { root: true })
                return response
            },
            error => {
                commit('loadInviteError')
                dispatch('alert/error', error, { root: true })
            }
        )
    },

    resendInvite ({ dispatch, commit }, params) {
        commit('loadInviteRequest')
        return groupSubscriptionService.resendInvite(params).then(
            response => {
                commit('loadInviteSuccess', response)
                dispatch('alert/success', 'We re-sent the invitation.', { root: true })
                return response
            },
            error => {
                commit('loadInviteError')
                dispatch('alert/error', error, { root: true })
            }
        )
    },

    loadMyInvites ({ dispatch, commit }, memberGuid) {
        commit('loadMyInvitesRequest')
        return groupSubscriptionService.getMyInvites(memberGuid).then(
            response => {
                commit('loadMyInvitesSuccess', response)
                return response
            },
            error => {
                commit('loadMyInvitesError')
                dispatch('alert/error', 'Unable to load invites: ' + error, { root: true })
            }
        )
    },

    acceptInvite ({ dispatch, commit }, params) {
        commit('loadInviteRequest')
        return groupSubscriptionService.acceptInvite(params).then(
            response => {
                dispatch('alert/success', 'Invite accepted.', { root: true })
                return response
            },
            error => {
                commit('loadInviteError')
                dispatch('alert/error', error, { root: true })
            }
        )
    },

}

const mutations = {
    loadListRequest (state) {
        state.busy = true
    },
    loadListSuccess (state, data) {
        state.subscriptions = data.subscriptions
        state.tiers = data.tiers
        state.offers = data.offers
        state.busy = false
    },
    loadListError (state) {
        state.subscriptions = []
        state.tiers = []
        state.offers = []
        state.busy = false
    },
    loadInvitesRequest (state) {
        state.invites = []
        state.busy = true
    },
    loadInvitesSuccess (state, data) {
        state.invites = data.invites
        state.busy = false
    },
    loadInvitesError (state) {
        state.invites = []
        state.busy = false
    },
    loadInviteRequest (state) {
        state.invite = {}
        state.busy = true
    },
    loadInviteSuccess (state, data) {
        state.invite = data.invite
        state.busy = false
    },
    loadInviteError (state) {
        state.invite = []
        state.busy = false
    },
    startRequest (state) {
        state.busy = true
    },
    endRequest (state) {
        state.busy = false
    },
    loadMyInvitesRequest (state) {
        state.myInvites = []
        state.busy = true
    },
    loadMyInvitesSuccess (state, data) {
        state.myInvites = data.invites
        state.busy = false
    },
    loadMyInvitesError (state) {
        state.myInvites = []
        state.busy = false
    },
}

const getters = {
    getSubscriptions (state) {
        return state.subscriptions
    },
    getTiers (state) {
        return state.tiers
    },
    getOffers (state) {
        return state.offers
    },
    isBusy (state) {
        return state.busy === true
    },
    getInvites (state) {
        return state.invites
    },
    getMyInvites (state) {
        return state.myInvites
    },
}

export const groupSubscriptionModule = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
